/* UMOJA direction B: smooth scroll, the hero intro and the craft chapter steps. Few effects, all calm. */
(function(){
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasG = !!window.gsap;
  if (hasG && !RM) document.documentElement.classList.add('js');
  window.UMOJA = {heroP:0, waxP:0, mouse:{x:.5,y:.5}};
  addEventListener('pointermove', e => { UMOJA.mouse.x = e.clientX/innerWidth; UMOJA.mouse.y = e.clientY/innerHeight; }, {passive:true});

  // mobile menu
  const mb = document.getElementById('menuBtn'), mn = document.getElementById('mmenu');
  const setMenu = open => { if (!mn) return; mn.hidden = !open; mb.setAttribute('aria-expanded', open); mb.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); document.body.classList.toggle('menu-open', open); };
  if (mb) mb.addEventListener('click', () => setMenu(mn.hidden));
  if (mn) mn.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  addEventListener('keydown', e => { if (e.key === 'Escape' && mn && !mn.hidden) setMenu(false); });

  // Art and Objects tabs (arrow keys move between them)
  const tabs = [...document.querySelectorAll('.tabs [role="tab"]')];
  const pick = t => tabs.forEach(b => { const on = b === t; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; document.getElementById(b.getAttribute('aria-controls')).hidden = !on; });
  tabs.forEach((b, i) => {
    b.addEventListener('click', () => pick(b));
    b.addEventListener('keydown', e => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { const n = tabs[(i + d + tabs.length) % tabs.length]; pick(n); n.focus(); } });
  });

  if (!hasG || RM) return;
  gsap.registerPlugin(ScrollTrigger);

  // smooth scroll
  if (window.Lenis) {
    const lenis = new Lenis({lerp:.08, smoothWheel:true});
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t*1000));
    gsap.ticker.lagSmoothing(0);
    document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => { const id = a.getAttribute('href'); const el = id.length > 1 && document.querySelector(id); if (el) { e.preventDefault(); lenis.scrollTo(el, {duration:1.8, offset:-64}); } }));
  }

  // hero: the scene fades in, then the title
  gsap.timeline({defaults:{ease:'expo.out'}})
    .from('.hero canvas, .hero .scene', {opacity:0, scale:1.04, duration:2.4, ease:'power2.out'})
    .from('.hero h1', {opacity:0, y:24, duration:1.4}, .5)
    .from('.hero .cue', {opacity:0, duration:1}, 1.2);
  // the scene drifts gently with the mouse, for depth
  const scene = document.getElementById('scene');
  if (scene) { const sx = gsap.quickTo(scene, 'x', {duration:1.2, ease:'power3'}), sy = gsap.quickTo(scene, 'y', {duration:1.2, ease:'power3'}); addEventListener('pointermove', e => { sx((e.clientX/innerWidth - .5) * -18); sy((e.clientY/innerHeight - .5) * -12); }, {passive:true}); }
  ScrollTrigger.create({trigger:'.hero', start:'top top', end:'bottom top', scrub:true, onUpdate:s => UMOJA.heroP = s.progress});
  gsap.to('.hero .copy', {yPercent:-18, opacity:0, ease:'none', scrollTrigger:{trigger:'.hero', start:'top top', end:'bottom top', scrub:true}});

  gsap.utils.toArray('[data-par]').forEach(img => gsap.fromTo(img, {yPercent:-5}, {yPercent:5, ease:'none', scrollTrigger:{trigger:img.parentElement, start:'top bottom', end:'bottom top', scrub:true}}));

  // craft chapter: wax, clay, fire, reveal
  const steps = [...document.querySelectorAll('.wax .st')], lis = [...document.querySelectorAll('#waxList li')], temp = document.getElementById('temp');
  const temps = ['Workshop · 32 °C','Drying · 45 °C','Pouring · 1,100 °C','Cooled · 40 °C'];
  let cur = 0;
  if (document.getElementById('craft')) ScrollTrigger.create({trigger:'#craft', start:'top top', end:'bottom bottom', scrub:true, onUpdate:s => {
    UMOJA.waxP = s.progress;
    const i = Math.min(3, Math.floor(s.progress*4*0.999));
    if (i !== cur) { cur = i; steps.forEach((el,k) => el.classList.toggle('on', k===i)); lis.forEach((el,k) => el.classList.toggle('on', k<=i)); if (temp) temp.textContent = temps[i]; }
  }});

  addEventListener('load', () => ScrollTrigger.refresh());
})();
